import React, { useEffect } from 'react'
import { CFormLabel as CLabel, CFormInput as CInput, CFormSelect as CSelect, CRow, CCol, CContainer } from '@coreui/react'

import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'

const EditPatientDetails = ({ formData, setFormData, isEditable = true, facility, setFacility }) => {
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function calculateAge(dob) {
    const today = new Date()
    const birthDate = new Date(dob)
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDifference = today.getMonth() - birthDate.getMonth()
    const dayDifference = today.getDate() - birthDate.getDate()
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--
    }
    let data = {
      target: { name: 'Age', value: age },
    }
    handleChange(data)
    return age
  }

  useEffect(() => {
    if (formData.DOB) {
      calculateAge(formData.DOB)
    }
  }, [formData.DOB])

  const handleFacility = (e) => {
    const { name, value } = e.target
    setFacility((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <CContainer>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="firstName">First Name</CLabel>
          <CInput className="ui-form-input" type="text" id="firstName" name="FirstName" value={formData.FirstName} onChange={handleChange} required disabled={!isEditable} />
        </CCol>
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="middleName">Middle Name</CLabel>
          <CInput className="ui-form-input" type="text" id="middleName" name="MiddleName" value={formData.MiddleName} onChange={handleChange} disabled={!isEditable} />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="lastName">Last Name</CLabel>
          <CInput className="ui-form-input" type="text" id="lastName" name="LastName" value={formData.LastName} onChange={handleChange} required disabled={!isEditable} />
        </CCol>
        <CCol md="6" className="flex-column d-flex">
          <CLabel className="ui-form-label" htmlFor="dob">Date of Birth</CLabel>
          {/* <CInput
            type="date"
            id="dob"
            name="DOB"
            value={formData.DOB}
            onChange={handleChange}
            required
            disabled={!isEditable}
          /> */}
          <CustomDatePickingFormat
            value={formData.DOB}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                DOB: e,
              }))
            }}
          />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="gender">Gender</CLabel>
          <CSelect className="ui-form-select" id="gender" name="Gender" value={formData.Gender} onChange={handleChange} required disabled={!isEditable}>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </CSelect>
        </CCol>
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="age">Age</CLabel>
          <CInput className="ui-form-input" type="number" id="age" name="Age" value={formData.Age} onChange={handleChange} required disabled={!isEditable} />
        </CCol>
      </CRow>
      {/* <CRow>
        <CCol md="6">
          <div className="my-3">
            <CLabel>Patient Status</CLabel>
            <Select
              placeholder="Select"
              name="Status"
              options={patientStatus}
            // value={formData.Status}
            // onChange={(e) => setFormData((prevData) => ({
            //   ...prevData,
            //   Status: e,
            // }))}
            />
          </div>
        </CCol>

      </CRow> */}
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="phoneNumber">Phone Number</CLabel>
          <CInput
            type="text"
            id="phoneNumber"
            name="PhoneNumber"
            value={formData.PhoneNumber}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="emergencyName">Emergency Contact Name</CLabel>
          <CInput className="ui-form-input" type="text" id="emergencyName" name="EmergencyName" value={formData.EmergencyName} onChange={handleChange} required disabled={!isEditable} />
        </CCol>
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="emergencyPhone">Emergency Contact Phone</CLabel>
          <CInput className="ui-form-input" type="text" id="emergencyPhone" name="EmergencyPhone" value={formData.EmergencyPhone} onChange={handleChange} required disabled={!isEditable} />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel className="ui-form-label" htmlFor="roomNumber">Room Number</CLabel>
          <CInput className="ui-form-input" type="text" id="roomNumber" name="roomNumber" placeholder="Enter room number" value={facility.roomNumber} onChange={handleFacility} required disabled={!isEditable} />
        </CCol>
        {/* <CCol md="6">
          <CLabel htmlFor="emergencyPhone">Status</CLabel>
          <Select
            name='Status'
            onChange={(e)=>{
              setFormData((prevData) => ({
               ...prevData,
                Status: e.value,
              }))
            }}
            value={selectedOption}
            options={selectStatusOption}
          />
        </CCol> */}
        {/* <CCol md="6">
          <CLabel htmlFor="address">Address</CLabel>
          <CInput
            type="text"
            id="address"
            name="Address"
            value={formData.Address}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="state">State</CLabel>
          <CInput
            type="text"
            id="state"
            name="State"
            value={formData.State}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="city">City</CLabel>
          <CInput
            type="text"
            id="city"
            name="City"
            value={formData.City}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="zipCode">Zip Code</CLabel>
          <CInput
            type="text"
            id="zipCode"
            name="ZipCode"
            value={formData.ZipCode}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="country">Country</CLabel>
          <CInput
            type="text"
            id="country"
            name="Country"
            value={formData.Country}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
    </CContainer>
  )
}

export default EditPatientDetails
